import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Radium, { keyframes } from 'higher-order-components/configured-radium/'

const SvgArrowUpIcon = () => (
  <svg
    style={{
      ...styles.iconSvg,
      ...styles.animateDown
    }}
    viewBox="0 0 9 5">
    <title>Arrow Up</title>
    <path fill="inherit" d="M4.5 1.4L.7 5 0 4.3 4.5 0 9 4.3l-.7.7-3.8-3.6z" />
  </svg>
)

const SvgArrowDownIcon = () => (
  <svg
    style={{
      ...styles.iconSvg,
      ...styles.animateDown
    }}
    viewBox="0 0 9 5">
    <title>Arrow down</title>
    <path fill="inherit" d="M0 .7L.7 0l3.8 3.6L8.3 0l.7.7L4.5 5 0 .7z" />
  </svg>
)

/**
 * Renders a Round Icon Button.
 * @todo  Change to stateless component
 */
class RoundIconButton extends Component {
  constructor() {
    super()
    this.state = {
      active: false
    }
  }
  static propTypes = {
    iconId: PropTypes.string.isRequired,
    onClick: PropTypes.func
  }
  static defaultProps = {
    iconId: '',
    onClick: () => { }
  }
  activate = () => {
    this.setState({ active: true })
  }
  reset = () => {
    this.setState({ active: false })
  }
  /**
   * @param {('arrow-up'|'arrow-down')} iconId - ID of svg icon.
   * @returns {ReactElement} react component
   */
  render() {
    return (
      <div
        style={[styles.base, this.state.active ? styles.baseActive : styles.baseDefault]}
        onMouseOver={this.activate}
        onMouseOut={this.reset}
        onClick={this.props.onClick}>
        <div
          style={[
            styles.iconBase,
            this.state.active ? styles.iconBaseActive : styles.iconBaseDefault
          ]}>
          {this.props.iconId === 'arrow-up' && <SvgArrowUpIcon />}
          {this.props.iconId === 'arrow-down' && <SvgArrowDownIcon />}
        </div>
      </div>
    )
  }
}
const slideDownKeyframes = keyframes({
  '0%': {
    opacity: 0,
    transform: 'translateY(-35%)'
  },
  '35%': {
    opacity: 1,
    transform: 'translateY(0)'
  },
  '65%': {
    opacity: 1,
    transform: 'translateY(0)'
  },
  '100%': {
    opacity: 0,
    transform: 'translateY(35%)'
  }
})

const styles = {
  base: {
    width: '3em',
    height: '3em',
    position: 'relative',
    borderRadius: '50%',
    border: 'solid #fff 2px',
    cursor: 'pointer',
    transition: 'background-color .25s'
  },
  baseDefault: {
    backgroundColor: 'transparent'
  },
  baseActive: {
    backgroundColor: '#fff'
  },
  iconBase: {
    fill: '#fff',
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    transition: 'fill .25s',
    display: 'flex'
  },
  iconBaseDefault: {
    fill: '#fff'
  },
  iconBaseActive: {
    fill: '#000'
  },
  iconSvg: {
    width: '30%',
    height: '30%',
    margin: 'auto'
  },
  animateDown: {
    animation: 'x 1.4s infinite',
    animationName: slideDownKeyframes
  }
}

export default Radium(RoundIconButton)



// WEBPACK FOOTER //
// ./src/containers/round-icon-button/index.jsx